import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#021F3F] border-t border-[#0A3D62]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-business/artifacts/0aqhee7b_Screenshot_20251206_155729_Chrome.png"
                alt="IndustryTOP Consulting"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t.home.slogan}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.nav.home}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/brands" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  {t.nav.brands}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.contact.title}</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>{t.contact.info.location}</li>
              <li>
                <a href="mailto:contact@industry-top.com" className="hover:text-[#D4AF37] transition-colors">
                  {t.contact.info.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#0A3D62]/30">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
              <p className="text-gray-400 text-sm text-center md:text-left">
                {t.footer.copyright}
              </p>
              <div className="flex items-center space-x-4 text-sm">
                <Link to="/privacy-policy" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  {t.footer.privacyPolicy}
                </Link>
                <span className="text-gray-600">|</span>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                  {t.footer.termsOfService}
                </Link>
              </div>
            </div>
            <a 
              href="https://digital.marexon.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors"
            >
              {t.footer.built}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;